import { SliceCreator } from "@/features/vidyo-call/types/vidyo-common";

export interface ScreenSharingState {
  screenShare: {
    isSharing: boolean;
    isParticipantScreenSharing: boolean;
    setIsSharing: (isSharing: boolean) => void;
    setIsParticipantScreenSharing: (isSharing: boolean) => void;
  };
}

export const createScreenSharingSlice: SliceCreator<
  keyof ScreenSharingState
> = (set) => ({
  screenShare: {
    isSharing: false,
    isParticipantScreenSharing: false,
    setIsSharing: (isSharing: boolean) => {
      set(
        (state) => {
          state.screenShare.isSharing = isSharing;
        },
        undefined,
        "screenShare/setIsSharing",
      );
    },
    setIsParticipantScreenSharing: (isSharing: boolean) => {
      set(
        (state) => {
          state.screenShare.isParticipantScreenSharing = isSharing;
        },
        undefined,
        "screenShare/setIsParticipantScreenSharing",
      );
    },
  },
});
